import { type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {},
    variants: [
        {
            props: { widgetVariant: "dashboard" },
            style: {
                [`.${simpleWidgetCardClasses.card}`]: {
                    "&:hover": {
                        borderColor: "#c30017",
                    },
                },
            },
        },
    ],
})
